import { ListSystemsResponse } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/aqora_service_pb';
import { aqoraClient } from '~/services/api/aqora-client';

export const SYSTEMS_PAGE_SIZE = BigInt(1000);

export const listSystems = async (): Promise<ListSystemsResponse> =>
  await aqoraClient.listSystems({
    pageSize: SYSTEMS_PAGE_SIZE,
    short: true,
  });

export const getSystem = (name: string) =>
  aqoraClient.getSystem({
    name,
  });
